import { EditorState, Modifier } from 'draft-js';
import { I18n } from 'react-redux-i18n';
import cx from 'classnames';

import './toolbar-name-button.styles.scss';

export const ToolbarNameButton = (props) => {
	const { editorState, onChange, className } = props;

	const execute = () => {
    const contentState = Modifier.replaceText(
      editorState.getCurrentContent(),
      editorState.getSelection(),
      "{NAME}",
      editorState.getCurrentInlineStyle()
    );

    onChange(EditorState.push(editorState, contentState, "insert-characters"));
	};

	return (
		<span 
			className={cx('rdw-option-wrapper TextEditorToolbarNameButton', className)} 
			title={I18n.t("Insert {NAME} placeholder")}
			onClick={execute}
		>
			{'{N}'}
		</span>
	);
};